import React, { Component } from 'react';
import { InputGroup, InputGroupAddon, Button, Input } from 'reactstrap';
import Autosuggest from 'react-autosuggest';
import accentFold from '../utils/accentFold';

import './autosuggest.css';

export class Select extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: []
    };
  }

  render() {
    let {
      valid,
      label,
      value,
      fetching,
      result = [],
      errors,
      onRefresh,
      onChange,
      onBlur = () => {},
      placeholder = label,
      disabled,
      maxLength,
      required,
      autoFocus,
      children,
      className,
      ...otherProps
    } = this.props;
    let { list } = this.state;

    return (
      <Autosuggest
        {...otherProps}
        suggestions={list}
        focusInputOnSuggestionClick={false}
        onSuggestionsFetchRequested={({ value, reason }) => {
          this.setState({
            list: result.filter(
              item =>
                0 <=
                accentFold(item.text.toLowerCase()).indexOf(
                  accentFold(value.toLowerCase())
                )
            )
          });
        }}
        onSuggestionsClearRequested={() => {
          this.setState({
            list: []
          });
        }}
        shouldRenderSuggestions={value =>
          1 < value.length &&
          (1 < list.length || !list[0] || list[0].text !== value)
        }
        getSuggestionValue={suggestion => suggestion.text}
        inputProps={{
          value,
          placeholder,
          onBlur,
          onChange,
          valid,
          disabled,
          maxLength,
          required,
          autoFocus
        }}
        renderSuggestion={(suggestion, { query, isHighlighted }) => (
          <span
            className={
              'suggestion-content' + (suggestion.disabled ? ' disabled' : '')
            }
          >
            {suggestion.text}
          </span>
        )}
        renderInputComponent={inputProps => (
          <InputGroup className={className} disabled={1 === fetching}>
            {label && (
              <InputGroupAddon
                addonType="prepend"
                className="d-none d-sm-block col-sm-4 col-md-3 col-xl-2"
              >
                {label}
              </InputGroupAddon>
            )}
            <Input {...inputProps} />
            <InputGroupAddon addonType="append">
              {2 !== fetching && 0 < errors.length && (
                <Button
                  onClick={onRefresh}
                  title={errors.reduce((prev, curr) => prev + curr, '')}
                >
                  <span
                    className={
                      'fa fa-refresh' + (1 === fetching ? ' fa-spin' : '')
                    }
                  />
                </Button>
              )}
              {children}
            </InputGroupAddon>
          </InputGroup>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Inputs.js